import React from 'react';
import Vaness from "../assets/vaness_img_512.webp";
import "../sass/layout/_banner.scss";
import { motion } from 'framer-motion';

export default function Banner() {
  return (
    <div className='ban'>
        <div className='ban__inner'>
            <span className='ban__name'>Vanessa <br /> MOIROD</span>
        </div>
        <div className="vaness_img">
            <img src={Vaness} alt='la phot de Vanesse MOIROD'/>
        </div>
        <div className="vanesss-txt">
            <p>Je vous propose une rencontre avec vous-même,</p>
            <p>afin que vous puissiez trouver les clés intérieures</p>
            <p>pour une évolution durable.</p>
            <motion.a
                href="https://www.institut-iihs.com/"
                target='_blank'
                rel='noreferrer'
                aria-label="Institut International D'hypnose Spirituelle"
                whileHover={{ scale: .85 }}
                whileFocus={{ scale: 0.9 }}
                whileTap={{ scale: 0.8 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
                <button type='button' className='btn'> L'hypnose spirituelle</button>
            </motion.a>
        </div>
    </div>
  )
}
